/* Configuratore: scelta della marca a riquadri con i loghi.

   Griglia di riquadri neri col logo della marca, due per riga: gli stessi
   loghi della pagina Semi-Personalizzate. Il logo riempie tutto il
   quadrato, niente cornice e niente scritte sopra.

   Le marche senza logo mostrano il nome dentro il riquadro, finche' il
   logo non c'e'. Per aggiungerlo basta scrivere il nome del file qui
   sotto, nella riga di quella marca.

   VALENTI e SUZUKI stanno in un riquadro solo: si clicca e poi si sceglie
   quale delle due. Stessa cosa per le marche con piu tipi (KTM, Yamaha,
   Kawasaki, Honda): prima la domanda, poi i pulsanti grandi.

   Lavora dal di fuori: le linguette restano nella pagina, solo nascoste,
   e i riquadri le cliccano. Cosi il motore del configuratore non viene
   toccato: se li dentro cambia qualcosa, al massimo questo non fa nulla.

   Gestisce anche l indirizzo /pages/crea-la-tua-grafica?grafica=...&marca=...
   usato dal tasto che sta sulle schede prodotto. */
(function () {
  var CDN = 'https://cdn.shopify.com/s/files/1/0996/4696/4042/files/';

  var MARCHE = [
    { nome: 'HM', logo: '02_hm_vent_20e8f978-3366-4203-aec2-1e18fc221cb4.png', tipi: [['', 'HM']] },
    { nome: 'Beta', logo: '9fef252f-e3d3-473a-8699-effbcac3fed3.png', tipi: [['', 'Beta']] },
    { nome: 'Husqvarna', logo: 'ChatGPT_Image_31_ago_2026_08_23_33.png', tipi: [['', 'Husqvarna']] },
    { nome: 'TM', logo: '07_tm_racing.png', tipi: [['', 'TM']] },
    { nome: 'Fantic', logo: '01_fantic.png', tipi: [['', 'Fantic']] },
    { nome: 'Valenti / Suzuki', logo: '05_valenti.png',
      domanda: 'Che marca è la tua moto?', tipi: [['Valenti', 'Valenti'], ['Suzuki', 'Suzuki']] },
    { nome: 'Gas Gas', logo: '10_gasgas.png', tipi: [['', 'Gas Gas']] },
    { nome: 'Sherco', logo: '06e3d3c3-018d-43ce-8fe9-bde01a126a29.png', tipi: [['', 'Sherco']] },
    { nome: 'KTM', logo: '03_ktm.png', tipi: [['Motard', 'KTM Motard'], ['Duke', 'KTM Duke'], ['Adventure', 'KTM Adventure']] },
    { nome: 'Yamaha', logo: '11_yamaha.png', tipi: [['Stradale', 'Yamaha Stradale'], ['Motard', 'Yamaha Motard'], ['Adventure', 'Yamaha Adventure']] },
    { nome: 'Kawasaki', logo: '08_kawasaki.png', tipi: [['Stradale', 'Kawasaki Stradale'], ['Motard', 'Kawasaki Motard']] },
    { nome: 'Honda', logo: '06_honda.png', tipi: [['Motard', 'Honda'], ['Stradale', 'Honda Stradale'], ['Adventure', 'Honda Adventure']] },
    { nome: 'BMW', logo: '09_bmw.png', tipi: [['', 'BMW']] }
  ];

  var CSS = [
    '#bcTabs{display:block;}',
    '#bcTabs .bc-tab{display:none !important;}',
    '.bc-marche{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px;}',
    '@media screen and (min-width:700px) and (max-width:1240px){.bc-marche{grid-template-columns:repeat(4,minmax(0,1fr));}}',
    '.bc-marca{display:block;width:100%;padding:0;margin:0;font:inherit;cursor:pointer;background:#000;border:0;overflow:hidden;}',
    '.bc-marca .foto{display:block;position:relative;aspect-ratio:1/1;overflow:hidden;background:#000;}',
    '.bc-marca img{display:block;width:100%;height:100% !important;object-fit:cover;padding:0;box-sizing:border-box;transition:transform .5s ease;}',
    '.bc-marca:hover img{transform:scale(1.05);}',
    '.bc-marca .senza{display:flex;position:absolute;inset:12%;align-items:center;justify-content:center;text-align:center;color:rgba(255,255,255,.85);font-weight:900;text-transform:uppercase;letter-spacing:.06em;font-size:clamp(1.3rem,1.8vw,2rem);border:2px dashed rgba(255,255,255,.28);padding:10px;}',
    '.bc-testa{display:flex;align-items:center;gap:14px;flex-wrap:wrap;margin-bottom:18px;}',
    '.bc-torna{font:inherit;font-size:1.2rem;font-weight:800;letter-spacing:.06em;text-transform:uppercase;padding:9px 16px;cursor:pointer;background:none;border:2px solid #000;color:#000;}',
    '.bc-torna:hover{background:#000;color:#fff;}',
    '.bc-qui{font-weight:900;text-transform:uppercase;font-size:1.9rem;letter-spacing:-.01em;}',
    '.bc-domanda{font-weight:900;text-transform:uppercase;letter-spacing:-.02em;line-height:1.05;',
    'font-size:clamp(2rem,2.6vw,2.9rem);margin:0 0 16px;color:#000;}',
    '.bc-tipi{display:grid;grid-template-columns:1fr;gap:12px;margin-bottom:18px;}',
    '@media screen and (min-width:560px){.bc-tipi{grid-template-columns:repeat(auto-fit,minmax(180px,1fr));}}',
    '.bc-tipo{font:inherit;font-size:1.7rem;font-weight:900;letter-spacing:.04em;text-transform:uppercase;',
    'padding:26px 22px;cursor:pointer;background:none;border:3px solid #000;color:#000;line-height:1.1;',
    'transition:background .15s,color .15s;}',
    '.bc-tipo:hover,.bc-tipo.scelto{background:#000;color:#fff;}',
    '.bc-invito{font-size:1.4rem;opacity:.75;margin:0 0 12px;}'
  ].join('');

  function metticss() {
    if (document.getElementById('bcCssMarche')) return;
    var s = document.createElement('style');
    s.id = 'bcCssMarche';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function linguetta(testo) {
    var tabs = document.querySelectorAll('.bc-tab');
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].textContent.trim() === testo) return tabs[i];
    }
    return null;
  }

  function pulisci(s) {
    return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function avvia() {
    var tabs = document.getElementById('bcTabs');
    var thumbs = document.getElementById('bcThumbs');
    if (!tabs || !tabs.querySelector('.bc-tab') || !thumbs) return false;
    if (tabs.dataset.grigliaPronta) return true;
    tabs.dataset.grigliaPronta = '1';
    metticss();

    var pannello = document.createElement('div');
    tabs.parentNode.insertBefore(pannello, tabs);

    var q = new URLSearchParams(location.search);
    var graficaChiesta = (q.get('grafica') || '').toLowerCase();

    function invito(testo) {
      var p = document.createElement('p');
      p.className = 'bc-invito';
      p.textContent = testo;
      return p;
    }

    function disponibile(m) {
      for (var i = 0; i < m.tipi.length; i++) if (linguetta(m.tipi[i][1])) return true;
      return false;
    }

    function mostraGriglia() {
      thumbs.style.display = 'none';
      pannello.innerHTML = '';
      pannello.appendChild(invito('Scegli la marca della tua moto.'));
      var g = document.createElement('div');
      g.className = 'bc-marche';
      MARCHE.forEach(function (m) {
        if (!disponibile(m)) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bc-marca';
        b.setAttribute('aria-label', m.nome);
        b.title = m.nome;
        var dentro = m.logo
          ? '<img loading="lazy" alt="' + m.nome + '" src="' + CDN + encodeURIComponent(m.logo) + '?width=600">'
          : '<span class="senza">' + m.nome + '</span>';
        b.innerHTML = '<span class="foto">' + dentro + '</span>';
        b.addEventListener('click', function () { scegliMarca(m); });
        g.appendChild(b);
      });
      pannello.appendChild(g);
    }

    function scegliMarca(m) {
      pannello.innerHTML = '';
      var testa = document.createElement('div');
      testa.className = 'bc-testa';
      var torna = document.createElement('button');
      torna.type = 'button';
      torna.className = 'bc-torna';
      torna.textContent = 'Cambia marca';
      torna.addEventListener('click', mostraGriglia);
      var qui = document.createElement('span');
      qui.className = 'bc-qui';
      qui.textContent = m.nome;
      testa.appendChild(torna);
      testa.appendChild(qui);
      pannello.appendChild(testa);

      var tipi = m.tipi.filter(function (t) { return linguetta(t[1]); });
      if (tipi.length <= 1) {
        apriTipo((tipi[0] || m.tipi[0])[1]);
        return;
      }

      var chiedi = document.createElement('p');
      chiedi.className = 'bc-domanda';
      chiedi.textContent = m.domanda || 'Che moto hai?';
      pannello.appendChild(chiedi);

      var riga = document.createElement('div');
      riga.className = 'bc-tipi';
      tipi.forEach(function (t) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bc-tipo';
        b.textContent = t[0];
        b.addEventListener('click', function () {
          var altri = riga.querySelectorAll('.bc-tipo');
          for (var i = 0; i < altri.length; i++) altri[i].classList.remove('scelto');
          b.classList.add('scelto');
          qui.textContent = m.nome.indexOf('/') !== -1 ? t[0] : (m.nome + ' · ' + t[0]);
          apriTipo(t[1]);
        });
        riga.appendChild(b);
      });
      pannello.appendChild(riga);
      thumbs.style.display = 'none';
    }

    function apriTipo(etichetta) {
      var t = linguetta(etichetta);
      if (t) t.click();
      thumbs.style.display = '';
    }

    if (graficaChiesta) {
      var marcaPar = q.get('marca') || '';
      var mappa = {
        'grafiche-hm-personalizzate-50-e-125': 'HM',
        'grafiche-personalizzate-beta-50-e-125': 'Beta',
        'grafiche-husqvarna-personalizzabili': 'Husqvarna',
        'grafiche-tm-personalizzate': 'TM',
        'grafiche-fantic-personalizzate': 'Fantic',
        'grafiche-valenti': 'Valenti',
        'grafiche-suzuki': 'Suzuki',
        'grafiche-gas-gas': 'Gas Gas',
        'grafiche-sherco': 'Sherco',
        'grafiche-ktm-motard': 'KTM Motard',
        'grafiche-ktm-duke': 'KTM Duke',
        'grafiche-ktm-adventure': 'KTM Adventure',
        'grafiche-yamaha-motard': 'Yamaha Motard',
        'grafiche-yamaha-stradale': 'Yamaha Stradale',
        'grafiche-yamaha-adventure': 'Yamaha Adventure',
        'grafiche-kawasaki-motard': 'Kawasaki Motard',
        'grafiche-kawasaki-stradale': 'Kawasaki Stradale',
        'grafiche-honda': 'Honda',
        'grafiche-honda-stradale': 'Honda Stradale',
        'grafiche-honda-adventure': 'Honda Adventure',
        'grafiche-bmw-adventure': 'BMW',
        'grafiche-bmw': 'BMW'
      };
      var etich = mappa[marcaPar];
      var madre = null, tipoNome = '';
      MARCHE.forEach(function (m) {
        m.tipi.forEach(function (t) { if (t[1] === etich) { madre = m; tipoNome = t[0]; } });
      });
      if (madre) {
        scegliMarca(madre);
        var q2 = pannello.querySelector('.bc-qui');
        if (q2 && tipoNome) q2.textContent = madre.nome.indexOf('/') !== -1 ? tipoNome : (madre.nome + ' · ' + tipoNome);
        var dom = pannello.querySelector('.bc-domanda');
        if (dom && dom.parentNode) dom.parentNode.removeChild(dom);
        var bottoni = pannello.querySelectorAll('.bc-tipo');
        for (var i = 0; i < bottoni.length; i++) {
          if (bottoni[i].textContent === tipoNome) bottoni[i].classList.add('scelto');
        }
      } else {
        mostraGriglia();
      }
      if (etich) {
        var t2 = linguetta(etich);
        if (t2) t2.click();
        thumbs.style.display = '';
      }
      var fuori = false;
      setTimeout(function () { fuori = true; }, 15000);
      var prova = setInterval(function () {
        if (fuori) { clearInterval(prova); return; }
        var nodi = thumbs.querySelectorAll('.bc-thumb');
        for (var i = 0; i < nodi.length; i++) {
          var nome = pulisci(nodi[i].textContent);
          if (nome && graficaChiesta.indexOf(nome) !== -1) {
            clearInterval(prova);
            nodi[i].click();
            var capo = document.getElementById('bc2');
            if (capo) capo.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }
        }
      }, 300);
      return true;
    }

    mostraGriglia();
    return true;
  }

  var scaduto = false;
  setTimeout(function () { scaduto = true; }, 15000);
  var attesa = setInterval(function () {
    if (scaduto) { clearInterval(attesa); return; }
    if (avvia()) clearInterval(attesa);
  }, 200);
})();
